
// @ts-nocheck


export const localeCodes =  [
  "en",
  "de",
  "es",
  "fr",
  "zh"
]

export const localeLoaders = {
  "en": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__opt_buildhome_repo_lang_en_json" */), cache: true }],
  "de": [{ key: "../lang/de.json", load: () => import("../lang/de.json" /* webpackChunkName: "locale__opt_buildhome_repo_lang_de_json" */), cache: true }],
  "es": [{ key: "../lang/es.json", load: () => import("../lang/es.json" /* webpackChunkName: "locale__opt_buildhome_repo_lang_es_json" */), cache: true }],
  "fr": [{ key: "../lang/fr.json", load: () => import("../lang/fr.json" /* webpackChunkName: "locale__opt_buildhome_repo_lang_fr_json" */), cache: true }],
  "zh": [{ key: "../lang/zh.json", load: () => import("../lang/zh.json" /* webpackChunkName: "locale__opt_buildhome_repo_lang_zh_json" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "i18n_config_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "name": "English",
      "iso": "en",
      "files": [
        "lang/en.json"
      ]
    },
    {
      "code": "de",
      "name": "Deutsch",
      "iso": "de",
      "files": [
        "lang/de.json"
      ]
    },
    {
      "code": "es",
      "name": "Español",
      "iso": "es",
      "files": [
        "lang/es.json"
      ]
    },
    {
      "code": "fr",
      "name": "Français",
      "iso": "fr",
      "files": [
        "lang/fr.json"
      ]
    },
    {
      "code": "zh",
      "name": "中文",
      "iso": "zh",
      "files": [
        "lang/zh.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": true,
  "langDir": "lang",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "name": "English",
    "iso": "en",
    "files": [
      {
        "path": "lang/en.json"
      }
    ]
  },
  {
    "code": "de",
    "name": "Deutsch",
    "iso": "de",
    "files": [
      {
        "path": "lang/de.json"
      }
    ]
  },
  {
    "code": "es",
    "name": "Español",
    "iso": "es",
    "files": [
      {
        "path": "lang/es.json"
      }
    ]
  },
  {
    "code": "fr",
    "name": "Français",
    "iso": "fr",
    "files": [
      {
        "path": "lang/fr.json"
      }
    ]
  },
  {
    "code": "zh",
    "name": "中文",
    "iso": "zh",
    "files": [
      {
        "path": "lang/zh.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
